import openErrorModal from "./ErrorModal";

export function openBackendValidationErrorModal(error: { body: string, status: number }) {
	if (error.status == 422) {
		const errorsObj = JSON.parse(error.body);
		let errorMessages: string[] = Object.entries(errorsObj).map(keyValueArray => keyValueArray[1][0]);
		openErrorModal(errorMessages, null, null, null, "auto");
	} else {
		openErrorModal();
	}
}
